import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class INDRAIbeAdminConfigService {

  private ibeadmin_debug = false; // to show/hide ibeadmin texts with asterisc mark and help development
	private configurationsObj: Object = {};
	private configurationsByKey = new Map<string, BehaviorSubject<string>>();
	private loadedModules = new Set<string>();

  constructor( private http: HttpClient ) { }

	loadConfigurations(scopeId: string, moduleIds: string[]): Observable<any> {
		const promise = new Promise<any>((resolve, reject) => this._loadConfigurations(scopeId, moduleIds, resolve, reject));
		return from(promise);
	}

	private _loadConfigurations(scopeId: string, moduleIds: string[], resolve: any, reject: any) {
		const modulesToLoad = new Array<string>();
		moduleIds.forEach(moduleId => {
			if (!this.loadedModules.has(moduleId))
				modulesToLoad.push(moduleId);
		});

		if (modulesToLoad.length > 0) {
			this.http.post<Object[]>(`${environment.api_url}ibe/rest/scopes/${scopeId}/modules/configurations`, { modules: modulesToLoad }).subscribe(
				data => {
					data.forEach(moduleTranslations => {
						if (this.configurationsObj)
							Object.assign(this.configurationsObj, moduleTranslations);
						else
							this.configurationsObj = moduleTranslations;
					});

					modulesToLoad.forEach(moduleId => {
						if (!this.loadedModules.has(moduleId))
							this.loadedModules.add(moduleId);
					});

					Array.from(this.configurationsByKey.keys()).forEach(
						key => this.configurationsByKey.get(key).next(this.getConfigurationValue(key))
					);
					resolve(data);
				},
				error => reject(error)
			);
		}
	}

	getConfigurationValue(key: string): string {
	  if (this.ibeadmin_debug) {
		  console.debug('[IBE-Admin] Getting configuration key ' + key);
	  }
		if (this.configurationsObj) {
			const keyValues: string[] = key.split('.');
			let result: Object = null;
			keyValues.forEach(value => {
				if (result === null)
					result = this.configurationsObj[value];
				else
					result = result[value] ? result[value] : '';
			});
			if (result) {
				if (this.ibeadmin_debug)
					return `*${result}*`;
				else
					return result.toString();
			} else {
				console.warn('[IBE-Admin] Configuration key not found: \'' + key + '\'');
				return key;
			}
		} else return key;
	}
}
